import { SeoHead } from "../components/common/SeoHead.tsx";
import { useI18n } from "../i18n/context.tsx";
import { ClassicCTA } from "../sections/classic/ClassicCTA.tsx";
import { ClassicHero } from "../sections/classic/ClassicHero.tsx";
import { CourtAnalytics } from "../sections/classic/CourtAnalytics.tsx";
import { OfflinePrivacy } from "../sections/classic/OfflinePrivacy.tsx";
import { SessionHistory } from "../sections/classic/SessionHistory.tsx";
import { VoiceControl } from "../sections/classic/VoiceControl.tsx";
import { WatchIntegration } from "../sections/classic/WatchIntegration.tsx";
import { buildJsonLdSoftwareApp, getSeoMeta } from "../utils/seo.ts";

export function ClassicPage() {
  const { locale } = useI18n();
  const meta = getSeoMeta("classic", locale);
  const jsonLd = buildJsonLdSoftwareApp({
    name: "ShootCreator Classic",
    description: meta.description,
    price: "0",
    priceCurrency: "USD",
    operatingSystem: "iOS, watchOS",
  });

  return (
    <>
      <SeoHead
        title={meta.title}
        description={meta.description}
        path="/basketball/classic"
        ogImage="/og-classic.png"
        jsonLd={jsonLd}
      />
      <ClassicHero />
      <VoiceControl />
      <WatchIntegration />
      <CourtAnalytics />
      <SessionHistory />
      <OfflinePrivacy />
      <ClassicCTA />
    </>
  );
}
